import styled from 'styled-components';

interface HeaderWrapperProps {
    $isScrolled: boolean;
}

interface MiniHeaderProps {
    $isVisible: boolean;
}

interface AderirButtonProps {
    $isVisible: boolean;
}

export const HeaderWrapper = styled.header<HeaderWrapperProps>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    transition: box-shadow 0.3s ease;
    box-shadow: ${({ $isScrolled }) => ($isScrolled ? '0 2px 8px rgba(0, 0, 0, 0.15)' : 'none')};
`;

export const MiniHeader = styled.div<MiniHeaderProps>`
    height: ${({ $isVisible }) => ($isVisible ? '32px' : '0')};
    background-color: #6e00e0;
    display: flex;
    align-items: center;
    overflow: hidden;
    transition: height 0.3s ease;
`;

export const MiniHeaderContainer = styled.div`
    max-width: 1360px;
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
`;

export const MiniHeaderLinks = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
`;

export const MiniHeaderLink = styled.a`
    font-family: 'Amigo', sans-serif;
    font-size: 13px;
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
`;

export const BigHeader = styled.div`
    height: 70px;
    background-color: #7d00ff;
    display: flex;
    align-items: center;
`;

export const BigHeaderContainer = styled.div`
    max-width: 1110px;
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const LogoContainer = styled.a`
    display: flex;
    align-items: center;
    cursor: pointer;

    svg {
        width: 108px;
        height: 40px;
    }
`;

export const AderirButton = styled.a<AderirButtonProps>`
    background-color: #ffffff;
    color: #7d00ff;
    font-family: 'Amigo', sans-serif;
    font-size: 16px;
    font-weight: 700;
    padding: 12px 32px;
    border-radius: 32px;
    text-decoration: none;
    cursor: pointer;
    transition: opacity 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
    pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
    transform: ${({ $isVisible }) => ($isVisible ? 'scale(1)' : 'scale(0.8)')};

    &:hover {
        color: rgb(181, 109, 255);
    }
`;
